import { useInfiniteQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getSpacesKey } from '../../utils/keys';
export const DefaultSpacesLimit = 10;
export const useSpaces = (options) => {
    const { variables = { limit: DefaultSpacesLimit }, fields = 'basic', useInfiniteQueryOptions, } = options || {};
    const { client } = useTribeClient();
    const spacesKey = getSpacesKey(variables);
    return useInfiniteQuery(spacesKey, ({ pageParam: after }) => client === null || client === void 0 ? void 0 : client.spaces.list({ after, ...variables }, fields), useInfiniteQueryOptions);
};
//# sourceMappingURL=useSpaces.js.map